<div class="flex error-message">
  <!-- <button mat-icon-button>
    <mat-icon
      [mdePopoverTriggerFor]="appPopover"
      [mdePopoverTriggerOn]="data?.data?.length > 0 ? 'hover' : 'none'"
      #popoverTrigger="mdePopoverTrigger"
      ><img src="assets/svg/icons/cancel_wht-lg.svg"
    /></mat-icon>
  </button> -->
  <div class="message">{{ data.message }}</div>
  <div class="dismiss">
    <button mat-icon-button (click)="dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mde-popover mdePopoverOffsetY="30" #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
  <mat-card>
    <mat-card-content>
      <div>
        <pre> {{ data.data }}</pre>
      </div>
    </mat-card-content>
  </mat-card>
</mde-popover>
